// extracted by mini-css-extract-plugin
export default {"blurb":"FeatureLivingNew_blurb__DKlHn","benefitBlendsContainer":"FeatureLivingNew_benefitBlendsContainer__kSPUn","hasBrochure":"FeatureLivingNew_hasBrochure__2X-Rd"};